import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M16.5 6.005v.75m0 3v.75m0 3v.75m0 3v.75m-9-5.25h5.25m-5.25 2.25h3m-7.125-9.75c-.621 0-1.125.503-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.197v3.027c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.027a2.999 2.999 0 0 1 0-5.197V6.38c0-.622-.504-1.125-1.125-1.125z"
    }, null, -1)
  ])))
}
export default { render: render }